import billNotifyDialogReducer from './billNotifyDialogReducer';

export default billNotifyDialogReducer;